<template>
    <select-input :id="id" ref="input" v-model="selected" v-bind="$attrs" :class="{ error: error }"
                  :label="label" :error="error" :required="required">
      <option :value="null">{{ $t('global.select_default_value')}}</option>
      <option :value="option.value" v-for="(option, key) in optionsFormatted" v-bind:key="key">{{option.label}}</option>
    </select-input>
</template>
<script>

import SelectInput from './SelectInput'

export default {
  name: 'SelectDropdown',
  components: {SelectInput},
  props: {
    options: Object,
    id: {
      type: String,
    },
    value: [String, Number, Boolean],
    label: String,
    error: String,
    required: Boolean
  },
  data() {
    return {
      selected: this.value,
    }
  },
  computed: {
    optionsFormatted(){
      let arr = []
      for (let elm in this.options) {
        arr.push({'label': this.options[elm].name, 'value': this.options[elm].id})
      }
      return arr
    }
  },
  watch: {
    selected(selected) {
      this.$emit('input', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style scoped>

</style>
